import {
  createContext,
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
  useContext,
} from 'react'
import { usePathname } from '@/hooks/use-pathname'
import { usePersistedSideNavExpanded } from '@/hooks/use-persisted-side-nav-expanded'
import { isDocumentsEditorSidenavPath } from '@/routes/documents-editor-paths'

export type SideNavExpandedContextValue = {
  sideNavExpanded: boolean
  setSideNavExpanded: Dispatch<SetStateAction<boolean>>
}

const SideNavExpandedContext = createContext<SideNavExpandedContextValue | null>(
  null
)

export const SideNavExpandedProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [preferred, setSideNavExpanded] = usePersistedSideNavExpanded()
  // Les écrans de saisie replient la sidenav sans toucher à la préférence : en sortant, on la
  // retrouve telle que l'utilisateur l'avait laissée.
  const sideNavExpanded =
    preferred && !isDocumentsEditorSidenavPath(usePathname())
  return (
    <SideNavExpandedContext.Provider
      value={{ sideNavExpanded, setSideNavExpanded }}
    >
      {children}
    </SideNavExpandedContext.Provider>
  )
}

export const useSideNavExpandedLayout = (): SideNavExpandedContextValue => {
  const ctx = useContext(SideNavExpandedContext)
  if (!ctx) {
    throw new Error(
      'useSideNavExpandedLayout must be used within SideNavExpandedProvider'
    )
  }
  return ctx
}
